import { useSelector, useDispatch } from 'react-redux';
import { isUndefined } from 'util';
import { Features } from '../../models/features';
import { StoreState } from '../state';
import { getFeatureFlags } from '../actions/feature';
import { useCallback } from 'react';

export function useFeature(feature: Features) {
  const dispatch = useDispatch();
  const [isLoading, value] = useSelector((state: StoreState) => [
    isUndefined(state.features.isLoading) || state.features.isLoading,
    !!state.features.all && !!state.features.all[feature],
  ]);

  const getFeatures = useCallback(
    () => dispatch(getFeatureFlags.request()),
    [dispatch],
  );

  return {
    isLoading,
    getFeatures,
    value,
  };
}
